export default "__VITE_ASSET__D2niVVC7__"